export default "__VITE_ASSET__9c151a14__"